import type { ReactNode, TableHTMLAttributes } from 'react';

import styles from './Table.module.css';

interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  children: ReactNode;
  /** Первая колонка закрепляется при горизонтальном скролле (DS §5.6). */
  stickyFirstColumn?: boolean | undefined;
  /** Зебра строк --color-surface-sunken. */
  zebra?: boolean | undefined;
  containerClassName?: string | undefined;
  className?: string | undefined;
}

/**
 * Таблица DESIGN_SYSTEM §5.6: обёртка с границей и радиусом карточки, шапка
 * и зебра `--color-surface-sunken`. Числа табличные и выровнены по правому
 * краю (класс `numeric` на ячейке), текст — по левому. На мобильном таблица
 * скроллится внутри собственного контейнера — страница не едет.
 */
export function Table({
  children,
  stickyFirstColumn = false,
  zebra = true,
  containerClassName,
  className,
  ...rest
}: TableProps) {
  return (
    <div className={[styles.container, containerClassName].filter(Boolean).join(' ')}>
      <table
        className={[
          styles.table,
          stickyFirstColumn && styles.stickyFirst,
          zebra && styles.zebra,
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        {...rest}
      >
        {children}
      </table>
    </div>
  );
}
